import { render } from "./Error401.vue?vue&type=template&id=70d181a4&ts=true"
import script from "./Error401.vue?vue&type=script&lang=ts"
export * from "./Error401.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__